import React from 'react';
import { Typography } from 'antd';
import { WorkerTimesheetStatus } from '@timekeeping/components';
import { WorksTimekeepingWorkerTimesheetStatus } from '@common/graphql/schema';

import { Link } from '@common/components';
import { FontSize } from '@common/tokens';

export const WorkerTimesheetPageTitle = ({
  workerName,
  status,
  assignmentId,
}: {
  workerName: string;
  status?: WorksTimekeepingWorkerTimesheetStatus;
  assignmentId: string | undefined;
}) => (
  <Typography.Title level={2}>
    <span style={{ fontSize: '1rem' }}>
      {status && <WorkerTimesheetStatus status={status} />}
    </span>
    <br />
    {workerName ? `${workerName}’s Timecard` : ''}
    {assignmentId && (
      <Link
        style={{ fontSize: FontSize.md, marginLeft: '16px' }}
        to={`/works/team/long_term/${assignmentId}/assignment`}
      >
        View assignment
      </Link>
    )}
  </Typography.Title>
);
